<template>
  <timeBlock
      v-for="(item, index) in timeList"
      :key="item"
      :item="item"
      :index="index"
      class="animate__animated animate__fadeInDown"
  ></timeBlock>
</template>

<script>
//时间线展示
import timeBlock from "./timeBlock";

export default {
  name: "timeLine",
  components: {timeBlock},
  data() {
    return {
      timeList: [
        {
          ro1: 1,
          time1: '2023-10-20 15:33:39',
          info1: '盆友圈功能上线',
          ro2: 2,
          time2: '2023-10-16 10:11:28',
          info2: '后端服务部署完毕,https搭建完毕'
        }, {
          ro1: 3,
          time1: '2023-09-26 15:19:42',
          info1: '博客文章模块调整完毕,首篇文章发布',
          ro2: 4,
          time2: '2023-09-22 13:40:16',
          info2: '备案完成'
        }, {
          ro1: 5,
          time1: '2023-09-11 09:31:12',
          info1: '搭建前端云服务,后端运行环境',
          ro2: 6,
          time2: '2023-09-07 15:12:39',
          info2: '准备云服务,域名,备案等'
        }, {
          ro1: 7,
          time1: '2023-09-07 11:14:02',
          info1: '开始开发前端内容,初步内容呈现',
          ro2: 8,
          time2: '2023-08-30 15:25:00',
          info2: '心血来潮,开始搭建网站'
        },
      ],
    }
  }
}
</script>

<style scoped>

</style>